import { createQueryKeys } from '@lukemorales/query-key-factory';

export const bookmarkQueryKeys = createQueryKeys('bookmark', {
  // addBookmark: (addBookmarkParams: AddBookmarkParams) => [addBookmarkParams],
  // deleteBookmark: (deleteBookmarkParams: DeleteBookmarkParams) => [deleteBookmarkParams],
  addBookmark: () => ['addBookmark'],
  deleteBookmark: () => ['deleteBookmark'],
});
